/* theme.js (storefront behavior, shared base)
   Progressive: everything renders server-side; this adds drawers, mega menus, predictive search,
   the cart drawer, variant switching, add-ons, filters and small niceties. No framework. */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const on = (el, ev, fn, o) => el && el.addEventListener(ev, fn, o);
  const money = (cents) => {
    try {
      const fmt = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: fmt }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';

  /* ---------- toast ---------- */
  let toastEl, toastTimer;
  function toast(msg, link) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '';
    toastEl.append(msg);
    if (link) { const a = document.createElement('a'); a.href = link.href; a.textContent = link.label; toastEl.append(a); }
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 3200);
  }

  /* ---------- drawers (mobile nav, cart, filters) ---------- */
  const Drawer = {
    open(el, opener) {
      if (!el) return;
      el.hidden = false; requestAnimationFrame(() => el.classList.add('is-open'));
      el._opener = opener || document.activeElement; document.body.classList.add('no-scroll');
      const f = $$(FOCUSABLE, el).filter(x => x.offsetParent !== null); (f[1] || f[0] || el).focus({ preventScroll: true });
      opener && opener.setAttribute && opener.setAttribute('aria-expanded', 'true');
    },
    close(el) {
      if (!el || !el.classList.contains('is-open')) return;
      el.classList.remove('is-open'); document.body.classList.remove('no-scroll');
      setTimeout(() => { el.hidden = true; }, 260);
      if (el._opener) { el._opener.setAttribute && el._opener.setAttribute('aria-expanded', 'false'); el._opener.focus && el._opener.focus({ preventScroll: true }); }
    },
    closeAll() { $$('.drawer.is-open').forEach(Drawer.close); Search.close(); }
  };
  on(document, 'click', (e) => {
    const openBtn = e.target.closest('[data-drawer-open]');
    if (openBtn) { e.preventDefault(); Drawer.open(document.getElementById(openBtn.dataset.drawerOpen), openBtn); return; }
    const closeBtn = e.target.closest('[data-drawer-close]');
    if (closeBtn) { e.preventDefault(); Drawer.close(closeBtn.closest('.drawer')); return; }
    const cartOpen = e.target.closest('[data-cart-open]');
    if (cartOpen && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) { e.preventDefault(); Drawer.open($('[data-cart-drawer]'), cartOpen); }
  });
  on(document, 'keydown', (e) => {
    if (e.key === 'Escape') { Drawer.closeAll(); Nav.closeAll(); const lb = $('[data-lightbox]'); lb && lb.open && lb.close(); }
    if (e.key === 'Tab') { // focus trap for open drawer / overlay
      const box = $('.drawer.is-open, .search-overlay.is-open');
      if (!box) return;
      const f = $$(FOCUSABLE, box).filter(x => x.offsetParent !== null); if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header: sticky + mega menus ---------- */
  const header = $('[data-header]');
  if (header) {
    const mode = header.dataset.sticky;
    let offset = 0;
    const measure = () => { offset = header.offsetTop + header.offsetHeight; };
    measure(); on(window, 'resize', measure);
    const tick = () => {
      if (mode === 'never') return;
      const y = window.scrollY;
      header.classList.toggle('is-stuck', mode === 'always' ? y > 8 : y > offset);
    };
    on(window, 'scroll', tick, { passive: true }); tick();
  }
  const Nav = {
    items: $$('[data-nav-item]'),
    timer: null,
    open(item) { Nav.items.forEach(i => i !== item && Nav.close(i)); item.classList.add('is-open'); const t = $('[data-nav-trigger]', item); t && t.setAttribute('aria-expanded', 'true'); },
    close(item) { item.classList.remove('is-open'); const t = $('[data-nav-trigger]', item); t && t.setAttribute('aria-expanded', 'false'); },
    closeAll() { Nav.items.forEach(Nav.close); }
  };
  Nav.items.forEach(item => {
    const trigger = $('[data-nav-trigger]', item); if (!trigger) return;
    on(item, 'mouseenter', () => { clearTimeout(Nav.timer); Nav.timer = setTimeout(() => Nav.open(item), 80); });
    on(item, 'mouseleave', () => { clearTimeout(Nav.timer); Nav.timer = setTimeout(() => Nav.close(item), 160); });
    on(trigger, 'click', (e) => { if (!item.classList.contains('is-open')) { e.preventDefault(); Nav.open(item); } });
    on(trigger, 'keydown', (e) => { if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); Nav.open(item); const f = $('[data-nav-panel] a', item); f && f.focus(); } });
    on(item, 'focusout', (e) => { if (!item.contains(e.relatedTarget)) Nav.close(item); });
  });
  on(document, 'click', (e) => { if (!e.target.closest('[data-nav-item]')) Nav.closeAll(); });

  /* ---------- search overlay + predictive ---------- */
  const Search = {
    el: $('[data-search-overlay]'),
    input: $('[data-search-input]'),
    results: $('[data-search-results]'),
    empty: $('[data-search-empty]'),
    timer: null, last: '', opener: null,
    open(opener) { if (!Search.el) return; Search.opener = opener; Search.el.hidden = false; requestAnimationFrame(() => Search.el.classList.add('is-open')); document.body.classList.add('no-scroll'); setTimeout(() => Search.input && Search.input.focus(), 60); opener && opener.setAttribute('aria-expanded', 'true'); },
    close() { if (!Search.el || !Search.el.classList.contains('is-open')) return; Search.el.classList.remove('is-open'); document.body.classList.remove('no-scroll'); setTimeout(() => { Search.el.hidden = true; }, 260); if (Search.opener) { Search.opener.setAttribute('aria-expanded', 'false'); Search.opener.focus(); } },
    async fetch(q) {
      if (q.length < 2) { Search.render(null); return; }
      try {
        const url = `${window.rssRoutes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search`;
        const r = await fetch(url); if (!r.ok) throw new Error(r.status);
        const html = await r.text(); const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = $('#shopify-section-predictive-search', doc); if (q !== Search.last) return;
        Search.render(inner ? inner.innerHTML : '');
      } catch (e) { Search.render(''); }
    },
    render(html) {
      if (html === null) { Search.results.innerHTML = ''; Search.results.append(Search.empty); Search.empty.hidden = false; return; }
      Search.results.innerHTML = html || '';
      if (!html || !html.trim()) { Search.results.append(Search.empty); Search.empty.hidden = false; }
    }
  };
  on(document, 'click', (e) => {
    const o = e.target.closest('[data-search-open]'); if (o) { e.preventDefault(); Search.open(o); return; }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); Search.close(); }
  });
  on(Search.input, 'input', () => { const q = Search.input.value.trim(); Search.last = q; clearTimeout(Search.timer); Search.timer = setTimeout(() => Search.fetch(q), 220); });

  /* ---------- cart ---------- */
  const Cart = {
    async add(items) {
      const r = await fetch(window.rssRoutes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      const data = await r.json(); if (!r.ok) throw new Error(data.description || data.message || window.rssStrings.cartError);
      await Cart.refresh(); return data;
    },
    async change(line, quantity) {
      const r = await fetch(window.rssRoutes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!r.ok) throw new Error(window.rssStrings.cartError);
      await Cart.refresh();
    },
    async refresh() {
      const r = await fetch(`${window.rssRoutes.cart}?section_id=cart-drawer`); const html = await r.text();
      const doc = new DOMParser().parseFromString(html, 'text/html'); const fresh = $('[data-cart-drawer]', doc); const cur = $('[data-cart-drawer]');
      if (fresh && cur) { const wasOpen = cur.classList.contains('is-open'); cur.innerHTML = fresh.innerHTML; if (wasOpen) { cur.classList.add('is-open'); cur.hidden = false; } }
      const cr = await fetch(window.rssRoutes.cart + '.js'); const cart = await cr.json();
      $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
      if (document.body.classList.contains('template-cart')) window.location.reload();
    }
  };
  on(document, 'click', async (e) => {
    const minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      const input = $('[data-qty-input]', (minus || plus).parentElement); if (!input) return;
      const min = parseInt(input.min || '0', 10); const v = Math.max(min, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1)); input.value = v; input.dispatchEvent(new Event('change', { bubbles: true })); return;
    }
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); rm.disabled = true; try { await Cart.change(parseInt(rm.dataset.line, 10), 0); } catch (err) { toast(err.message); rm.disabled = false; } }
  });
  on(document, 'change', async (e) => {
    const input = e.target.closest('[data-qty-input][data-line]'); if (!input) return;
    try { await Cart.change(parseInt(input.dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0)); } catch (err) { toast(err.message); }
  });

  /* ---------- product ---------- */
  const productRoot = $('[data-product]');
  if (productRoot) {
    const jsonEl = $('[data-product-json]'); const product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    const form = $('#ProductForm'); const idInput = $('[data-variant-id]'); const addBtn = $('[data-add-button]'); const addLabel = $('[data-add-label]');
    const priceBox = $('.product__price'); const err = $('[data-form-error]'); const sticky = $('[data-sticky-cta]');
    const picker = $('[data-variant-picker]');

    function selectedOptions() {
      const opts = [];
      $$('[data-option-group]', picker).forEach(g => { const c = $('input:checked', g); opts[parseInt(g.dataset.optionIndex, 10) - 1] = c ? c.value : null; });
      $$('[data-option-select]', picker).forEach(s => { opts[parseInt(s.dataset.optionIndex, 10) - 1] = s.value; });
      return opts;
    }
    function findVariant(opts) { return product.variants.find(v => v.options.every((o, i) => o === opts[i])); }
    let currentVariant = product ? (product.variants.find(x => String(x.id) === String(idInput && idInput.value)) || product.variants[0]) : null;
    function selectedAddons() {
      return $$('[data-addon-variant]:checked').map(c => ({ id: parseInt(c.dataset.addonVariant, 10), price: parseInt(c.dataset.addonPrice, 10) || 0, title: c.dataset.addonTitle || '' }));
    }
    function renderPrice(v) {
      if (!priceBox) return;
      if (v) currentVariant = v; else v = currentVariant;
      const cur = $('[data-price-current]', priceBox), cmp = $('[data-price-compare]', priceBox), sav = $('[data-savings]', priceBox), br = $('[data-price-breakdown]', priceBox);
      if (!v || !v.price) { return; }
      const addons = selectedAddons(); const addonTotal = addons.reduce((t, a) => t + a.price, 0); const total = v.price + addonTotal;
      if (cur) cur.textContent = money(total);
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      $('[data-price]', priceBox) && $('[data-price]', priceBox).classList.toggle('price--sale', !!onSale && addons.length === 0);
      if (cmp) { cmp.hidden = !onSale || addons.length > 0; if (onSale) cmp.lastChild.textContent = money(v.compare_at_price); }
      if (sav) { sav.hidden = !onSale; if (onSale) sav.textContent = sav.textContent.replace(/[\d.,$€£]+.*$/, money(v.compare_at_price - v.price)); }
      if (br) {
        br.hidden = addons.length === 0;
        if (addons.length) br.textContent = money(v.price) + ' + ' + addons.length + (addons.length === 1 ? ' add-on ' : ' add-ons ') + money(addonTotal) + ' = ' + money(total) + ' total';
      }
      const sp = $('[data-sticky-price]'); sp && (sp.textContent = money(total));
    }
    on(document, 'change', (e) => { if (e.target.closest('[data-addon-variant]')) renderPrice(); });
    function updateAvailability(v) {
      $$('[data-option-group]', picker).forEach(g => {
        const idx = parseInt(g.dataset.optionIndex, 10) - 1; const sel = selectedOptions();
        $$('input', g).forEach(inp => {
          const test = sel.slice(); test[idx] = inp.value;
          const anyAvail = product.variants.some(vr => vr.available && vr.options.every((o, i) => i === idx || test[i] == null ? true : o === test[i]) && vr.options[idx] === inp.value);
          inp.closest('.variant-option').classList.toggle('variant-option--unavailable', !anyAvail);
        });
      });
      if (!addBtn) return;
      if (!v) { addBtn.disabled = true; addLabel.textContent = window.rssStrings.unavailable; }
      else if (!v.available) { addBtn.disabled = true; addLabel.textContent = window.rssStrings.soldOut; }
      else { addBtn.disabled = false; addLabel.textContent = window.rssStrings.addToCart; }
      const sa = $('[data-sticky-add]'); if (sa) { sa.disabled = addBtn.disabled; sa.textContent = addLabel.textContent; }
    }
    function showMedia(mediaId) {
      if (!mediaId) return;
      $$('[data-slide]').forEach(s => s.classList.toggle('is-active', String(s.dataset.mediaId) === String(mediaId)));
      $$('[data-thumb]').forEach(t => { const a = String(t.dataset.mediaId) === String(mediaId); t.classList.toggle('is-active', a); t.setAttribute('aria-selected', a ? 'true' : 'false'); });
    }
    function onVariantChange() {
      if (!product) return;
      const opts = selectedOptions(); const v = findVariant(opts);
      $$('[data-option-group]', picker).forEach(g => { const lbl = $('[data-selected-label]', g); const c = $('input:checked', g); if (lbl && c) lbl.textContent = c.value; });
      if (v) {
        idInput && (idInput.value = v.id); renderPrice(v);
        if (v.featured_media) showMedia(v.featured_media.id);
        const url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      }
      updateAvailability(v);
    }
    on(picker, 'change', onVariantChange);
    if (picker) updateAvailability(findVariant(selectedOptions()));

    // gallery
    on(document, 'click', (e) => { const t = e.target.closest('[data-thumb]'); if (t) showMedia(t.dataset.mediaId); });
    const lb = $('[data-lightbox]');
    on($('[data-zoom]'), 'click', () => { const img = $('[data-slide].is-active img'); if (!img || !lb) return; const big = $('[data-lightbox-img]', lb); big.src = img.currentSrc || img.src; big.alt = img.alt; lb.showModal(); });
    on($('[data-lightbox-close]'), 'click', () => lb.close());
    on(lb, 'click', (e) => { if (e.target === lb) lb.close(); });

    // add to cart with add-ons
    async function submitAdd() {
      if (!form || !idInput) return;
      const qty = Math.max(1, parseInt(($('[data-qty-input]', form) || {}).value, 10) || 1);
      const items = [{ id: parseInt(idInput.value, 10), quantity: qty }];
      $$('[data-addon-variant]:checked').forEach(c => items.push({ id: parseInt(c.dataset.addonVariant, 10), quantity: 1 }));
      addBtn.disabled = true; const prev = addLabel.textContent; addLabel.textContent = window.rssStrings.adding; err.hidden = true;
      try {
        await Cart.add(items);
        const mode = document.body.dataset.cartType || 'drawer';
        if (mode === 'page') { window.location.href = window.rssRoutes.cart; return; }
        if (mode === 'drawer' && $('[data-cart-drawer]')) Drawer.open($('[data-cart-drawer]'), addBtn); else toast(window.rssStrings.added, { href: window.rssRoutes.cart, label: 'View cart' });
      } catch (ex) { err.textContent = ex.message; err.hidden = false; }
      finally { addBtn.disabled = false; addLabel.textContent = prev; }
    }
    on(form, 'submit', (e) => { e.preventDefault(); submitAdd(); });
    on($('[data-sticky-add]'), 'click', submitAdd);
    if (sticky && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 }).observe(form);
    }
    // related products
    const rel = $('[data-related]');
    if (rel && rel.dataset.url) fetch(rel.dataset.url).then(r => r.text()).then(html => { const d = new DOMParser().parseFromString(html, 'text/html'); const inner = $('[data-related]', d); if (inner) rel.innerHTML = inner.innerHTML; }).catch(() => {});
  }

  /* ---------- collection: filters + sort via Section Rendering API ---------- */
  const colRoot = $('[data-collection-root]');
  if (colRoot) {
    const sectionEl = colRoot.closest('.shopify-section'); const sectionId = sectionEl ? sectionEl.id.replace('shopify-section-', '') : null;
    let timer;
    async function apply(params, push) {
      const url = new URL(window.location.pathname, window.location.origin); url.search = params.toString();
      colRoot.style.opacity = '.5';
      try {
        const r = await fetch(`${url.pathname}?${params.toString()}&section_id=${sectionId}`); const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html'); const fresh = $('[data-collection-root]', doc);
        if (fresh) { colRoot.innerHTML = fresh.innerHTML; }
        if (push) history.pushState({}, '', url.toString());
      } catch (e) { window.location.href = url.toString(); }
      colRoot.style.opacity = '';
    }
    function collect() {
      const p = new URLSearchParams();
      const form = $('[data-facets-form]', colRoot) || $('[data-facets-form]');
      if (form) new FormData(form).forEach((v, k) => { if (v !== '') p.append(k, v); });
      const sort = $('[data-sort-form] select', colRoot); if (sort) p.set('sort_by', sort.value);
      return p;
    }
    on(document, 'change', (e) => {
      if (e.target.closest('[data-facets-form]') || e.target.closest('[data-sort-form]')) {
        clearTimeout(timer); timer = setTimeout(() => apply(collect(), true), e.target.type === 'number' ? 600 : 0);
      }
    });
    on(document, 'click', (e) => { const a = e.target.closest('.facets__active a, .facets__clear, .pagination a'); if (a && colRoot.contains(a)) { e.preventDefault(); const u = new URL(a.href); apply(u.searchParams, true); if (a.closest('.pagination')) window.scrollTo({ top: colRoot.offsetTop - 80, behavior: 'smooth' }); } });
    on(window, 'popstate', () => apply(new URL(window.location).searchParams, false));
  }

  /* ---------- product comparison ---------- */
  const Compare = {
    key: 'rss-compare', max: 3,
    tray: $('[data-compare-tray]'), modal: $('[data-compare-modal]'), content: $('[data-compare-content]'),
    selection: [], opener: null,
    productFromToggle(toggle) {
      return {
        handle: toggle.value,
        title: toggle.dataset.compareTitle || '',
        url: toggle.dataset.compareUrl || '',
        image: toggle.dataset.compareImage || '',
        price: toggle.dataset.comparePrice || '',
        workspace: toggle.dataset.compareWorkspace || '',
        frame: toggle.dataset.compareFrame || '',
        automation: toggle.dataset.compareAutomation || '',
        bestFor: toggle.dataset.compareBestFor || ''
      };
    },
    read() {
      if (!window.RSSCompare) return [];
      try {
        const saved = window.RSSCompare.normalizeSelection(JSON.parse(localStorage.getItem(Compare.key) || '[]'), Compare.max);
        return saved.map((item) => {
          const toggle = $$('[data-compare-toggle]').find((candidate) => candidate.value === item.handle);
          return toggle ? Object.assign({}, item, Compare.productFromToggle(toggle)) : item;
        });
      } catch (err) { return []; }
    },
    write() {
      try { localStorage.setItem(Compare.key, JSON.stringify(Compare.selection)); } catch (err) {}
    },
    syncToggles() {
      const handles = new Set(Compare.selection.map((item) => item.handle));
      $$('[data-compare-toggle]').forEach((toggle) => { toggle.checked = handles.has(toggle.value); });
    },
    element(tag, className, text) {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text) node.textContent = text;
      return node;
    },
    renderCard(product) {
      const card = Compare.element('article', 'compare-card');
      if (product.image) {
        const img = Compare.element('img', 'compare-card__image');
        img.src = product.image; img.alt = product.title || ''; img.loading = 'lazy'; card.appendChild(img);
      }
      const title = Compare.element('h3', 'compare-card__title');
      const link = Compare.element('a', '', product.title || product.handle.replace(/-/g, ' '));
      link.href = product.url || `/products/${product.handle}`; title.appendChild(link); card.appendChild(title);
      if (product.price) card.appendChild(Compare.element('div', 'compare-card__price', product.price));
      const specs = Compare.element('dl', 'compare-card__specs');
      [['Mounting', product.workspace], ['Spout height', product.frame], ['Filtration', product.automation], ['Best for', product.bestFor]].forEach(([label, value]) => {
        specs.appendChild(Compare.element('dt', '', label));
        specs.appendChild(Compare.element('dd', value ? '' : 'muted', value || 'Not listed'));
      });
      card.appendChild(specs);
      const remove = Compare.element('button', 'link compare-card__remove', 'Remove');
      remove.type = 'button'; remove.dataset.compareRemove = product.handle; card.appendChild(remove);
      return card;
    },
    render() {
      if (!Compare.tray) return;
      const count = Compare.selection.length;
      Compare.tray.hidden = count === 0;
      document.body.classList.toggle('has-compare-tray', count > 0);
      const countEl = $('[data-compare-count]', Compare.tray); if (countEl) countEl.textContent = count;
      const hint = $('[data-compare-hint]', Compare.tray);
      if (hint) hint.textContent = count < 2 ? 'Select one more product to compare.' : `Ready to compare ${count} products.`;
      const open = $('[data-compare-open]', Compare.tray); if (open) open.disabled = count < 2;
      if (Compare.content) {
        Compare.content.innerHTML = '';
        const grid = Compare.element('div', 'compare-modal__grid');
        grid.classList.add(`compare-modal__grid--${Compare.selection.length}`);
        Compare.selection.forEach((product) => grid.appendChild(Compare.renderCard(product)));
        Compare.content.appendChild(grid);
      }
      if (count < 2) Compare.close();
    },
    open(opener) {
      if (!Compare.modal || Compare.selection.length < 2) return;
      Compare.opener = opener || document.activeElement;
      Compare.render(); Compare.modal.hidden = false;
      requestAnimationFrame(() => Compare.modal.classList.add('is-open'));
      document.body.classList.add('no-scroll');
      const close = $('[data-compare-close]', Compare.modal); close && close.focus({ preventScroll: true });
    },
    close() {
      if (!Compare.modal || Compare.modal.hidden) return;
      Compare.modal.classList.remove('is-open'); document.body.classList.remove('no-scroll');
      setTimeout(() => { Compare.modal.hidden = true; }, 220);
      Compare.opener && Compare.opener.focus && Compare.opener.focus({ preventScroll: true });
    },
    clear() {
      Compare.selection = []; Compare.write(); Compare.syncToggles(); Compare.render();
    },
    remove(handle) {
      Compare.selection = Compare.selection.filter((item) => item.handle !== handle);
      Compare.write(); Compare.syncToggles(); Compare.render();
    },
    init() {
      Compare.selection = Compare.read(); Compare.write(); Compare.syncToggles(); Compare.render();
    }
  };
  Compare.init();
  on(document, 'change', (e) => {
    const toggle = e.target.closest('[data-compare-toggle]'); if (!toggle || !window.RSSCompare) return;
    const result = window.RSSCompare.toggleSelection(Compare.selection, Compare.productFromToggle(toggle), toggle.checked, Compare.max);
    if (result.limitReached) { toggle.checked = false; toast(`Compare up to ${Compare.max} products at a time`); return; }
    Compare.selection = result.selection; Compare.write(); Compare.syncToggles(); Compare.render();
    if (result.shouldOpen) Compare.open(toggle);
  });
  on(document, 'click', (e) => {
    const open = e.target.closest('[data-compare-open]');
    if (open) { e.preventDefault(); Compare.open(open); return; }
    if (e.target.closest('[data-compare-clear]')) { e.preventDefault(); Compare.clear(); return; }
    const remove = e.target.closest('[data-compare-remove]');
    if (remove) { e.preventDefault(); Compare.remove(remove.dataset.compareRemove); return; }
    if (e.target.closest('[data-compare-close]')) { e.preventDefault(); Compare.close(); }
  });
  on(document, 'keydown', (e) => { if (e.key === 'Escape') Compare.close(); });

  document.body.dataset.cartType = document.body.dataset.cartType || (window.rssCartType || 'drawer');
})();
